import {
    FETCH_FILTER_BRANDS_BEGIN,
    FETCH_FILTER_BRANDS_SUCCESS,
    FETCH_FILTER_BRANDS_FAILURE,
    FETCH_COMMON_DETAILS_BEGIN,
    FETCH_COMMON_DETAILS_SUCCESS,
    FETCH_COMMON_DETAILS_FAILURE
} from '../constants/commonActionTypes';
import { FilterBrands, commonDetailService } from '../services/common.services';
import { config } from '../env_config/react-config';

export const fetchFilterBrandsRequest = () => ({
    type: FETCH_FILTER_BRANDS_BEGIN
});

export const fetchFilterBrandsSuccess = result => ({
    type: FETCH_FILTER_BRANDS_SUCCESS,
    payload: result
});

export const fetchFilterBrandsFailure = (error) => ({
    type: FETCH_FILTER_BRANDS_FAILURE,
    payload: error
});

export const fetchCommonDetailsRequest = () => ({
    type: FETCH_COMMON_DETAILS_BEGIN
});

export const fetchCommonDetailsSuccess = result => ({
    type: FETCH_COMMON_DETAILS_SUCCESS,
    payload: result
});

export const fetchCommonDetailsFailure = (error) => ({
    type: FETCH_COMMON_DETAILS_FAILURE,
    payload: error
});

export const fetchFilterBrands = () => dispatch => {
    dispatch(fetchFilterBrandsRequest());
    FilterBrands().then(result => {
        if (result && result.length) {
            dispatch(fetchFilterBrandsSuccess(result));
        }
    }).catch(error => {
        dispatch(fetchFilterBrandsFailure(error));
    });
}

export const fetchCommonDetails = (retailerId) => dispatch => {
    if (retailerId) {
        dispatch(fetchCommonDetailsRequest());
        if(navigator.onLine){
            commonDetailService(retailerId).then(result => {
                if (result && result.length) {
                    localStorage.setItem(config.countryCode+'commonDetailService'+retailerId, JSON.stringify(result));
                    dispatch(fetchCommonDetailsSuccess(result));
                } else {
                    dispatch(fetchCommonDetailsFailure("fetch_empty"));
                }
            }).catch(error => {
                dispatch(fetchCommonDetailsFailure(error));
            });
        } else {
            const result = localStorage.getItem(config.countryCode+'commonDetailService'+retailerId);
            if(result === null){
                dispatch(fetchCommonDetailsFailure('offline'));
            } else {
                dispatch(fetchCommonDetailsSuccess(JSON.parse(result)));
            }
        }
    } else {
        dispatch(fetchCommonDetailsFailure("fetch_empty"));
    }
}
